(function() {
    'use strict';

    angular
        .module('telestatApp')
        .constant('paginationConstants', {
            /*
            'itemsPerPage': 20
            */
            'itemsPerPage': 30,
            'itemsPerLargePage': 50
        });
})();
